import * as types from './mutation-types';
import { defaultServiceTributesState } from './state';

export default {
  [types.RESET_SERVICE_TRIBUTES](state) {
    Object.assign(state.tributes, defaultServiceTributesState());
  },
  [types.SET_SUMMARY_SERVICE_TRIBUTES](state, payload) {
    state.summaryServiceTributes = payload;
  },
  [types.SET_PAGINATION_SERVICE_TRIBUTES](state, payload) {
    state.paginationServiceTributes = payload;
  },
  [types.SET_DETAILED_SERVICE_TRIBUTES](state, payload) {
    state.tributes = payload;
  },
  [types.SET_TRIBUTES_WARNINGS](state, payload) {
    state.warnings = payload;
  },
};
